import { useEffect } from "react";
import Lenis from "lenis";

let active: Lenis | null = null;

/**
 * Inertia scrolling (Lenis) for the long event page only: the registration
 * flow keeps native scrolling so focus moves and the keyboard behave exactly
 * as the browser does. Off with prefers-reduced-motion and on touch, where the
 * platform already has its own momentum.
 */
export function useSmoothScroll() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 0.95, smoothWheel: true, syncTouch: false });
    active = lenis;
    let frame = requestAnimationFrame(function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      if (active === lenis) active = null;
    };
  }, []);
}

/** Scrolls to an in-page section with the same inertia, or natively when Lenis is off. */
export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  if (active) active.scrollTo(el, { offset: -88 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
  // Keyboard and screen-reader users land in the section, not just look at it.
  el.focus({ preventScroll: true });
}
